import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/icons/icon.png';
import './Navbar.scss';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location.pathname]);

  const menuItems = [
    { label: 'Home', to: '/' },
    { label: 'Services', to: '/offerings' },
    { label: 'About', to: '/about-us' },
    { label: 'Careers', to: '/careers' },
  ];

  const handleToggleClick = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <nav className={`navbar-showcase ${isScrolled ? 'navbar-scrolled' : ''} ${isMobileMenuOpen ? 'navbar-mobile-open' : ''}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          <img src={logo} alt="Evib logo" className="navbar-logo-img" />
          <span>Evib</span>
        </Link>

        <ul className="navbar-menu">
          {menuItems.map((item, index) => (
            <li key={index} className="nav-item">
              {item.to.startsWith('#') ? (
                <a href={item.to}>{item.label}</a>
              ) : (
                <Link to={item.to}>{item.label}</Link>
              )}
            </li>
          ))}
        </ul>

        <button
          className="navbar-toggle"
          aria-label="Toggle menu"
          aria-expanded={isMobileMenuOpen}
          onClick={handleToggleClick}
        >
          <span className="toggle-bar"></span>
          <span className="toggle-bar"></span>
          <span className="toggle-bar"></span>
        </button>
      </div>

      <div className="navbar-mobile-menu">
        <ul>
          {menuItems.map((item, index) => (
            <li key={index}>
              {item.to.startsWith('#') ? (
                <a href={item.to}>{item.label}</a>
              ) : (
                <Link to={item.to}>{item.label}</Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
